module.exports = __webpack_public_path__ + "media/luxury-2026/estate-pool-house-drone-c0489904.jpg";